<template>
    <Forms ref="searchReports"
            :title="'Filtrar dados'"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            v-on:Clear="Clear"
            v-on:Search="Search"
            v-on:Load ="onLoad"
          >
        <div>
          <div id="form-search">
              <label class="labelseach">Patologias</label>

              <multiselect v-model="patologiaInternoArray"  :multiple="true"  :taggable="true" placeholder="Selecione uma Patologia" :options="patologiaArray" label="text" @tag="addTag" track-by="value" :close-on-select="false">
              </multiselect>

              <label  class="labelseach mt-3">Empreendimento</label>

              <multiselect v-model="empreendimentoInternoArray"  :multiple="true"  :taggable="true" placeholder="Selecione um Empreendimento" :options="empreendimentoArray" label="nomeEmpreendimento" @tag="addTag" track-by="id" :close-on-select="false">
              </multiselect>

              <label  class="labelseach mt-3">Status do Chamado</label>
              <multiselect v-model="statusInternoArray" :multiple="true" placeholder="Selecione um Status" :options="statusocorrencia" label="text" track-by="value" :close-on-select="false">
              </multiselect>

              <label class="labelseach mt-3">Período</label>
              <div class="periodos">
                <button id="semanal" class="btn-periodos"  v-on:click="filter">SEMANAL</button>
                <button id="mensal"  class="btn-periodos" v-on:click="filter">MENSAL</button>
                <button id="anual" class="btn-periodos" v-on:click="filter">ANUAL</button>
                <button id="personalizado" class="btn-periodos" v-on:click="filter">PERSONALIZADO</button>
              </div>
              <div class="d-flex align-items-end mt-3" v-if="dataspersonalizadas">
                <b-form-datepicker
                    ref = "DataInicio"
                    v-model ="formSearch.dataInicio"
                    placeholder="__/__/__"
                    locale="pt-BR"
                    :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>

                <label class="labelseach ml-1 mr-1" > à </label>
                <b-form-datepicker
                    v-model ="formSearch.dataFinal"
                    placeholder="__/__/__"
                    locale="pt-BR"
                    :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
                </div>
          </div>
        </div>
    </Forms>

</template>

<script>
import searchReports from './searchReports'
export default searchReports
</script>

<style scoped>
.form-control {
    display: flex;
    align-items: center;
    width: 100%;
    height: calc(2em + 0.75rem + 2px);
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #b0b5ba;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #e0e1e2;
    border-radius: 7px;
    -webkit-transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
}
.margem{
  margin-bottom: 7%;
}

#form-search{
  display: flex;
  flex-direction: column;
  align-content: center;
}

.labelseach{
  font: normal normal normal 16px/21px Segoe UI;
  letter-spacing: 0px;
  color: #2A2A2A;

}

.btn-periodos{
  background-color: #EBEBEB;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 139px;
  font-weight: bold;
  color: grey;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
  font-family:'Segoe UI';
}
.btn-periodos:focus{
   background-color: #008148;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
  font-family:'Segoe UI';
}

.btn-periodos-active{
   background-color: #008148;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
  font-family:'Segoe UI';
}

.periodos {
  display: flex;
 flex-wrap: wrap;
 justify-content: space-around;
 column-gap: 1rem;
}

#app.zopone .text-third{

  font-size: 16px;
  font-weight: normal;

}
:deep(.multiselect .multiselect__tags) {
    padding: 0px 40px 0 8px;
    border: 1px solid #ced4da;
    font-size: 14px;
  }

.periodos-container{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-self: stretch;
  justify-items: center;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/reports/components/searchReports/searchReports.vue